import React from 'react';
import { useLogin } from '../../hooks/useLogin';

import {
  Alert,
  AlertTitle,
  Box,
  Container,
  Grid,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

const Login: React.FC = () => {
  const [email, setEmail] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');

  const {
    error,
    setError,
    needsVerification,
    loading,
    login,
  } = useLogin();

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await login(email, password);
  };

  return (
    <Container component="main" maxWidth="xs">
      {!needsVerification && (
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 3,
            p: 3,
          }}
        >
          <Typography component="h1" variant="h5">
            Tutor Login
          </Typography>
          {error && (
            <Alert id="alert" severity="error" data-testid="login-error-alert" onClose={() => setError('')}>
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleLogin} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="email"
                  type="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  inputProps={{ "data-testid": "login-email-input" }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  inputProps={{ "data-testid": "login-password-input" }}
                />
              </Grid>
            </Grid>
            <LoadingButton
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              loading={loading}
              disabled={loading}
              data-testid="login-submit-button"
            >
              Login
            </LoadingButton>
            <Grid container>
              <Grid item xs>
                <Link href="/forgot-password" variant="body2" data-testid="login-forgot-password-link">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link href="/signup" variant="body2" data-testid="login-create-account-link">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default Login;
